export const OPEN_TEMPLATE_LIBRARY_STORAGE_KEY = 'hivett_open_template_library';
